export const configGetProdotto = (data) => {
    return {
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-Prodotto',
            metodo: 'getProdotto',
            ACL: ''
        },
        data
    }
}
export const configGetProdotti = (data) => {
    return {
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-Prodotto',
            metodo: 'getProdotti',
            ACL: ''
        },
        data
    }
}
export const configSetProdottoGenerale = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-Prodotto',
            metodo: 'setProdottoGenerale',
            ACL: ''
        },
        data
    })
}
export const configGetDizionariCombo = (data) => {
    return {
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Diz-Dizionari',
            metodo: 'getDizionariCombo',
            ACL: ''
        },
        data
    }

}

export const configDeleteProdottoCodici = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-ProdottoCodice',
            metodo: 'deleteProdottoCodici',
            ACL: 'invoice-list'
        },
        data
    })
}

export const configSetProdottoCodici = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-Prodotto',
            metodo: 'setProdottoCodici',
            ACL: 'invoice-list'
        },
        data
    })
}

export const configSetProdottoCaratteristiche = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-Prodotto',
            metodo: 'setProdottoCaratteristiche',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetMagazzini = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-Magazzino',
            metodo: 'getMagazzini',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetProdottiMagazzino = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-Prodotto',
            metodo: 'getProdottiMagazzino',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configSetMovimentiMagazzino = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-MovimentoMagazzino',
            metodo: 'setMovimentiMagazzino',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetListini = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-Listino',
            metodo: 'getListini',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configSetListini = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-Listino',
            metodo: 'setListino',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configDeleteListini = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-Listino',
            metodo: 'deleteListini',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configDeleteProdotti = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-Prodotto',
            metodo: 'deleteProdotti',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetQtaAttualeMagazzini = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-QtaAttualeMagazzino',
            metodo: 'getQtaAttualeMagazzini',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetMovimentiMagazzino = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-MovimentoMagazzino',
            metodo: 'getMovimentiMagazzino',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetPuntiVendita = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-PuntoVendita',
            metodo: 'getPuntiVendita',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configSetAliquoteIva = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Diz-AliquotaIva',
            metodo: 'setAliquoteIva',
            ACL: ''
        },
        data
    })
}
export const configDeleteAliquoteIva = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Diz-AliquotaIva',
            metodo: 'deleteAliquoteIva',
            ACL: ''
        },
        data
    })
}
export const configGetAliquoteIva = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Diz-AliquotaIva',
            metodo: 'getAliquoteIva',
            ACL: ''
        },
        data
    })
}
export const configSetUnitaMisura = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Diz-UnitaMisura',
            metodo: 'setUnitaMisura',
            ACL: ''
        },
        data
    })
}

export const configDeleteUnitaMisura = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Diz-UnitaMisura',
            metodo: 'deleteUnitaMisura',
            ACL: ''
        },
        data
    })
}
export const configDeleteUnitaUtilizzo = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Diz-UnitaUtilizzo',
            metodo: 'deleteUnitaUtilizzo',
            ACL: ''
        },
        data
    })
}
export const configSetUnitaUtilizzo = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Diz-UnitaUtilizzo',
            metodo: 'setUnitaUtilizzo',
            ACL: ''
        },
        data
    })
}
export const configSetStatiServizio = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Diz-StatoServizio',
            metodo: 'setStatiServizio',
            ACL: ''
        },
        data
    })
}
export const configDeleteStatiServizio = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Diz-StatoServizio',
            metodo: 'deleteStatiServizio',
            ACL: ''
        },
        data
    })
}
export const configSetPuntoVendita = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-PuntoVendita',
            metodo: 'setPuntoVendita',
            ACL: ''
        },
        data
    })
}
export const configDeletePuntoVendita = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-PuntoVendita',
            metodo: 'deletePuntoVendita',
            ACL: ''
        },
        data
    })
}
export const configSetMagazzino = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-Magazzino',
            metodo: 'setMagazzino',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configDeleteMagazzino = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-Magazzino',
            metodo: 'deleteMagazzino',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configSetReparto = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-Reparto',
            metodo: 'setReparto',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetReparti = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-Reparto',
            metodo: 'getReparti',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configDeleteReparti = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-Reparto',
            metodo: 'deleteReparti',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetCataloghi = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-Catalogo',
            metodo: 'getCataloghi',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configSetCatalogo = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-Catalogo',
            metodo: 'setCatalogo',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configDeleteCataloghi = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-Catalogo',
            metodo: 'deleteCataloghi',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetLottiSeriali = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-LottiSeriali',
            metodo: 'getLottiSeriali',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configSetLottiSeriali = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-LottiSeriali',
            metodo: 'setLottiSeriali',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configDeleteLottiSeriali = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-LottiSeriali',
            metodo: 'deleteLottiSeriali',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetPlui = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Dev-Plu',
            metodo: 'getPlui',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetPluiPuntoVendita = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Dev-Plu',
            metodo: 'getPluiPuntoVendita',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configSetPlu = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Dev-Plu',
            metodo: 'setPlu',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configDeletePlu = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Dev-Plu',
            metodo: 'deletePlu',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configSetPluRepository = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Dev-PluRepository',
            metodo: 'setPluRepository',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetPluiRepository = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Dev-PluRepository',
            metodo: 'getPluiRepository',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configInvioPluRepository = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Dev-PluRepository',
            metodo: 'invioPluRepository',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configSetImportDdtDanea = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-Magazzino',
            metodo: 'setImportDdtDanea',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetPuntoVendita = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-PuntoVendita',
            metodo: 'getPuntoVendita',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetQtaAttualeMagazziniCategorie = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-QtaAttualeMagazzino',
            metodo: 'getQtaAttualeMagazziniCategorie',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetIncassoPuntiVendita = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-PuntoVendita',
            metodo: 'getIncassoPuntiVendita',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetPuntiVenditaStatistiche = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-PuntoVendita',
            metodo: 'getPuntiVenditaStatistiche',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetOrganizzazioneStatistiche = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Log-PuntoVendita',
            metodo: 'getOrganizzazioneStatistiche',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetUtentiInterni = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Utente',
            metodo: 'getUtentiInterni',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configRegistrazioneUtenteInterno = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Utente',
            metodo: 'registrazioneUtenteInterno',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetProfili = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Acl',
            metodo: 'getProfili',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configSetProfiloPersona = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Utente',
            metodo: 'setProfiloPersona',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetProfiloL1 = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Acl',
            metodo: 'getProfiloL1',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetPermissions = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Acl',
            metodo: 'getPermissions',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configCreaProfilo = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Acl',
            metodo: 'creaProfilo',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configSetProfiloL1 = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Acl',
            metodo: 'setProfiloL1',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetLoginHistory = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Utente',
            metodo: 'getLoginHistory',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetModificheHistory = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Utente',
            metodo: 'getModificheHistory',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetScontrini = (data) => {
    return ({
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Dev-Battuta',
            metodo: 'getScontrini',
            ACL: 'invoice-list'
        },
        data
    })
}
export const configGetCategorie = (data) => {
    return {
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-Categoria',
            metodo: 'getCategorie',
            ACL: ''
        },
        data
    }
}
export const configSetCategoria = (data) => {
    return {
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-Categoria',
            metodo: 'setCategoria',
            ACL: ''
        },
        data
    }
}
export const configDeleteCategorie = (data) => {
    return {
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Cat-Categoria',
            metodo: 'deleteCategorie',
            ACL: ''
        },
        data
    }
}
export const configJobBattute = (data) => {
    return {
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Dev-Battuta',
            metodo: 'jobBattute',
            ACL: ''
        },
        data
    }
}
export const configSetAnagrafica = (data) => {
    return {
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Ana-Anagrafica',
            metodo: 'setAnagrafiche',
            ACL: ''
        },
        data
    }
}
export const configGetRecapiti = (data) => {
    return {
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Ana-AnaRecapito',
            metodo: 'getRecapiti',
            ACL: ''
        },
        data
    }
}
export const configGetAnagrafiche = (data) => {
    return {
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Ana-Anagrafica',
            metodo: 'getAnagrafiche',
            ACL: ''
        },
        data
    }
}
export const configSetRecapito = (data) => {
    return {
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Ana-AnaRecapito',
            metodo: 'setRecapiti',
            ACL: ''
        },
        data
    }
}

export const configGetContatti = (data) => {
    return {
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Ana-AnaContatto',
            metodo: 'getContatti',
            ACL: ''
        },
        data
    }
}
export const configSetContatti = (data) => {
    return {
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Ana-AnaContatto',
            metodo: 'setContatti',
            ACL: ''
        },
        data
    }
}
export const configDeleteContatti = (data) => {
    return {
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Ana-AnaContatto',
            metodo: 'deleteContatti',
            ACL: ''
        },
        data
    }
}
export const configDeleteAnagrafiche = (data) => {
    return {
        method: "post",
        url: process.env.REACT_APP_URL_API_SERVER,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
            classe: 'Ana-Anagrafica',
            metodo: 'deleteAnagrafiche',
            ACL: ''
        },
        data
    }
}

